/**
 * Quem fez a mudança, como a trilha o mostra: o nome do cadastro local
 * quando há, senão o código (o `sub` do token). O código vai no tooltip
 * só quando o nome o substituiu.
 *
 * A rotina de inatividade (2026-10-23) grava com um autor que não é `sub`
 * de ninguém (`rotina:inatividade`, `core/user_access/repository.py`): a
 * tela o traduz, em vez de mostrar o código.
 */

import type { ConfigAuditEntry } from "@/shared/api/api-client";

const AUTORES_AUTOMATICOS: Record<string, string> = {
  "rotina:inatividade": "Rotina automática (inatividade)"
};

/** O rótulo de um código de autor que não é pessoa, ou `undefined`. */
export function automaticAuthorLabel(code: string | null | undefined): string | undefined {
  return code ? AUTORES_AUTOMATICOS[code] : undefined;
}

export function auditAuthorLabel(entry: Pick<ConfigAuditEntry, "changed_by" | "changed_by_name">): string {
  return entry.changed_by_name || automaticAuthorLabel(entry.changed_by) || entry.changed_by || "—";
}

export function auditAuthorTitle(entry: Pick<ConfigAuditEntry, "changed_by" | "changed_by_name">): string | undefined {
  return entry.changed_by_name ? (entry.changed_by ?? undefined) : undefined;
}
